import { cn } from "@utils/tw"
import { defineBlock } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Date Logo",
  icon: "calendar",
  inserter: false,
  lazyLoad: false,
}

export default defineBlock("parts/header-date-lockup", (props) => {
  if (!props.enableDates && !env.admin) {
    return null
  }
  return (
    <div className={cn("h-full flex gap-3", props.enableDates ? "" : "opacity-20")}>
      <div className="w-[1px] bg-fg" />
      <div
        dangerouslySetInnerHTML={{ __html: props.logoSvg ?? "" }}
        className="h-full el-svg:h-full el-svg:block el-svg:w-auto el-svg:fill-current"
      />
    </div>
  )
})
